import React, { useState, useEffect } from "react";
import { Table, Button, InputGroup, Form } from "react-bootstrap";
import Switch from "react-switch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import "./MaschineSettingsSection.css";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";

export default function MaschineSettingsSection({
  validation,
  onChange,
  instanceTemplateConfig,
  disabled,
  path,
  invalidPath,
  inputPlaceholder,
}) {
  const [newPath, setNewPath] = useState("");
  const [patharray, setPatharray] = useState(
    validation.vm_configuration.value.startup_applications || []
  );
  const [decodedConfig, setDecodedConfig] = useState([]);

  useEffect(() => {
    if (instanceTemplateConfig) {
      try {
        const decodedConfiguration = atob(instanceTemplateConfig);
        const parsedConfig = JSON.parse(decodedConfiguration);
        const parsedVmConfig = JSON.parse(parsedConfig.static.vm_configuration);
        setDecodedConfig(parsedVmConfig.startup_applications);
      }catch (err){
        console.log(err);
        setDecodedConfig([]);
      }

    }
  }, [instanceTemplateConfig]);

  useEffect(() => {
    setPatharray(validation.vm_configuration.value.startup_applications);
  }, [validation]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleAddPath(newPath);
    }
  };

  const handleToggleAutostart = (index) => {
    let newPatharray = patharray.map((item, i) =>
      i === index ? { ...item, autoStart: !item.autoStart } : item
    );

    const newVmConfig = {
      ...validation.vm_configuration,
      value: {
        ...validation.vm_configuration.value,
        startup_applications: newPatharray,
      },
    };

    setPatharray(newPatharray);
    onChange(newVmConfig);
  };

  function handleDeletePath(path) {
    const newPatharray = patharray.filter((item) => item.path !== path);

    const newVmConfig = {
      ...validation.vm_configuration,
      value: {
        ...validation.vm_configuration.value,
        startup_applications: newPatharray,
      },
    };

    setPatharray(newPatharray);
    onChange(newVmConfig);
  }

  function handleAddPath(path) {
    const newPath = path.replace(/\\\\/g, "\\");

    if (!patharray.some((obj) => obj.path === newPath) && newPath !== "") {
      const newPatharray = [...patharray, { path: newPath, autoStart: true }];

      const newVmConfig = {
        ...validation.vm_configuration,
        value: {
          ...validation.vm_configuration.value,
          startup_applications: newPatharray,
        },
      };

      setPatharray(newPatharray);
      onChange(newVmConfig);
      setNewPath("");
    }
  }
  return (
    <>
      <Table size="sm" className="students-table mt-2">
        <thead>
          <tr>
            <th style={{ width: "75%" }}>{path}</th>
          </tr>
        </thead>
        <tbody>
          {patharray
            ? patharray.map((item, index) => (
                <tr key={item.path}>
                  <td style={{ width: "75%" }}>{item.path}</td>
                  <td>
                    <Switch
                      checked={item.autoStart}
                      onChange={() => handleToggleAutostart(index)}
                      className="float-right mx-2"
                      onColor="#54BF8D"
                      height={18}
                      width={40}
                      disabled={disabled}
                    />
                  </td>
                  {!decodedConfig.some(
                    (configItem) => configItem.path === item.path
                  ) ? (
                    <td>
                      <Button
                        className="btn btn-red btn-sm floatRight mx-2"
                        onClick={() => handleDeletePath(item.path)}
                        disabled={disabled}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </td>
                  ) : (
                    <td></td>
                  )}
                </tr>
              ))
            : null}
        </tbody>
      </Table>

      <InputGroup className="mt-4">
        <Form.Control
          onKeyDown={
            newPath !== "" && ValidationHelper.isPath(newPath)
              ? (event) => handleKeyPress(event)
              : () => {}
          }
          type="text"
          name="new_path"
          value={newPath}
          onChange={(e) => setNewPath(e.target.value)}
          placeholder={inputPlaceholder}
          disabled={disabled}
          isInvalid={newPath !== "" ? !ValidationHelper.isPath(newPath) : false}
        />
        <Button
          variant="btn btn-green"
          disabled={
            newPath !== ""
              ? disabled || !ValidationHelper.isPath(newPath)
              : true
          }
          onClick={() => handleAddPath(newPath)}
          style={{
            borderBottomLeftRadius: "0px",
            borderTopLeftRadius: "0px",
          }}
        >
          <FontAwesomeIcon icon={faPlus} />
        </Button>
        <Form.Control.Feedback type="invalid">
          {invalidPath}
        </Form.Control.Feedback>
      </InputGroup>
    </>
  );
}
